export const brochures = {
label: 'Product Brochures',
page_title: 'Product Brochures',
page_subtitle: 'Access the official One More Global Inc. product brochures in English and Spanish.',
section_title: 'Product Brochures',
section_description: 'Download or view our official product brochures in English and Spanish.',

// English Brochure
en_card_title: 'English Product Brochure',
en_card_description: 'View the official One More Global Inc. U.S. Product Catalog in English.',
en_button: 'Open English Brochure',

// Spanish Brochure
es_card_title: 'Folleto de Productos en Espanol',
es_card_description: 'Consulta el catalogo oficial de productos de One More Global Inc. en espanol.',
es_button: 'Abrir Folleto en Espanol',
};
